var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMicrosoftDynamics = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2695_2097",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 0H0V96H96V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2695_2097)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2695_2097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 48C0 52.2526 2.94943 55.8163 6.91426 56.7571C10.3435 72.9252 23.0749 85.6565 39.2429 89.0857C40.1837 93.0506 43.7474 96 48 96C52.2526 96 55.8163 93.0506 56.7571 89.0857C72.9251 85.6565 85.6565 72.9252 89.0857 56.7572C93.0505 55.8164 95.9999 52.2527 95.9999 48.0001C95.9999 43.7476 93.0506 40.1839 89.0858 39.243C85.6566 23.0749 72.9252 10.3435 56.7571 6.91426C55.8163 2.94943 52.2526 0 48 0C43.7474 0 40.1837 2.94943 39.2429 6.91426C23.0748 10.3435 10.3435 23.0749 6.91426 39.2429C2.94943 40.1837 0 43.7474 0 48Z",
    fill: "#8DF7DB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2695_2097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 96C74.5097 96 96 74.5097 96 48C96 21.4903 74.5097 0 48 0C21.4903 0 0 21.4903 0 48C0 74.5097 21.4903 96 48 96Z",
    fill: "url(#paint0_linear_2695_2097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 17.0645C54.9634 15.5918 57 12.5337 57 9C57 4.02944 52.9706 0 48 0C43.0294 0 39 4.02944 39 9C39 12.5337 41.0365 15.5918 44 17.0645V23H52V17.0645Z",
    fill: "#9DF3F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 78.9355C41.0366 80.4082 39 83.4663 39 87C39 91.9706 43.0294 96 48 96C52.9706 96 57 91.9706 57 87C57 83.4663 54.9634 80.4082 52 78.9355V73H44V78.9355Z",
    fill: "#82EBF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0645 44C15.5918 41.0366 12.5337 39 9 39C4.02944 39 -2.17271e-07 43.0294 0 48C2.1727e-07 52.9706 4.02944 57 9 57C12.5337 57 15.5918 54.9634 17.0645 52H23V44H17.0645Z",
    fill: "#9DF3F9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2695_2097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 76C62.3594 76 74 64.3594 74 50C74 35.6406 62.3594 24 48 24C33.6406 24 22 35.6406 22 50C22 64.3594 33.6406 76 48 76Z",
    fill: "black",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3172 54C57.6698 58.6608 53.2249 62 48 62C41.3726 62 36 56.6274 36 50C36 43.3726 41.3726 38 48 38C53.2249 38 57.6698 41.3393 59.3172 46H80V54H59.3172Z",
    fill: "black",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 59C82.0294 59 78 54.9706 78 50C78 45.0295 82.0294 41 87 41C91.9706 41 96 45.0295 96 50C96 54.9706 91.9706 59 87 59Z",
    fill: "black",
    fillOpacity: 0.32
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2695_2097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 74.3799C62.3594 74.3799 74 62.7393 74 48.3799C74 34.0205 62.3594 22.3799 48 22.3799C33.6406 22.3799 22 34.0205 22 48.3799C22 62.7393 33.6406 74.3799 48 74.3799Z",
    fill: "black",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3172 52.3799C57.6698 57.0407 53.2249 60.3799 48 60.3799C41.3726 60.3799 36 55.0073 36 48.3799C36 41.7525 41.3726 36.3799 48 36.3799C53.2249 36.3799 57.6698 39.7192 59.3172 44.3799H80V52.3799H59.3172Z",
    fill: "black",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 57.3799C82.0294 57.3799 78 53.3505 78 48.3799C78 43.4094 82.0294 39.3799 87 39.3799C91.9706 39.3799 96 43.4094 96 48.3799C96 53.3505 91.9706 57.3799 87 57.3799Z",
    fill: "black",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48 74C62.3594 74 74 62.3594 74 48C74 33.6406 62.3594 22 48 22C33.6406 22 22 33.6406 22 48C22 62.3594 33.6406 74 48 74Z",
    fill: "url(#paint1_linear_2695_2097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3172 52C57.6698 56.6608 53.2249 60 48 60C41.3726 60 36 54.6274 36 48C36 41.3726 41.3726 36 48 36C53.2249 36 57.6698 39.3393 59.3172 44H80V52H59.3172Z",
    fill: "url(#paint2_linear_2695_2097)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 57C82.0294 57 78 52.9706 78 48C78 43.0295 82.0294 39 87 39C91.9706 39 96 43.0295 96 48C96 52.9706 91.9706 57 87 57Z",
    fill: "url(#paint3_linear_2695_2097)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2695_2097",
    x: 14,
    y: 16,
    width: 90,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_2695_2097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2695_2097",
    x: 21.24,
    y: 21.6199,
    width: 75.52,
    height: 53.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.38,
    result: "effect1_foregroundBlur_2695_2097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2695_2097",
    x1: 22.7027,
    y1: 11.3514,
    x2: 72.6487,
    y2: 84.6487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007D85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2695_2097",
    x1: 31.7838,
    y1: 26.2703,
    x2: 66.1622,
    y2: 83.3514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36E3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2695_2097",
    x1: 31.1352,
    y1: 23.9999,
    x2: 75.2433,
    y2: 63.5675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82EBF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2695_2097",
    x1: 96.9731,
    y1: 50.9189,
    x2: 72.3244,
    y2: 42.1621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AEEF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82EBF1"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicrosoftDynamics);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/microsoftDynamics.40c12d4dc66895fceaa1f37a18e332b1.svg";